import React, {useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContentComponent } from './components';
import {Sidebar} from 'app/components';
import { menuItems } from './data/data';
import './style';
import { MoneyWavy } from '@phosphor-icons/react';
import { getAllEventsList, getBusinessConfig, getEventList } from './api';

const EventList = () => {
  const [selectedItem, setSelectedItem] = useState(menuItems[0]);

  const { userData } = useSelector((state) => state.app);
  const { businessConfig = {} } = useSelector((state) => state.eventList);

  const handleMenuClick = (item) => {
    setSelectedItem(item);
  };
  const banner={
    icon:<MoneyWavy size={32} />,
    heading: 'Make sure you get paid!',
    content: 'Setup Payout method to receive payments.',
    cta:'Add payout',
    ctaLink:()=>handleMenuClick(menuItems[1]),
  }

  useEffect(() => {
    if (userData?.business_config_id) {
      getAllEventsList(userData.business_config_id);
      getBusinessConfig(userData.business_config_id);
    } else getAllEventsList('-', { past: false, upcoming: false, live: false });
  }, [userData?.business_config_id]);

  return (
    <div className='page-container flex w-full h-full overflow-auto mt-[100px] min-h-screen'>
      <Sidebar
        width='280px'
        menuItems={menuItems} 
        onMenuClick={handleMenuClick}
        className='side-bar' 
        selectedItem={selectedItem.value}  
        banner={!businessConfig?.payment_details?.bank_name ? banner : null}
        colorMode={'black'}
      />
      <ContentComponent 
        content={selectedItem.content}
        className='content px-32 py-16 w-full'
      />
     
    </div>
  );
};

export default EventList;